export enum OrderType {
  INDIVIDUAL = "individual_order",
  COMBINED = "combined_order"
}
